export default __webpack_public_path__ + "static/media/piper-castlerock-crop.8d1b8c15.jpg";